import React from 'react';
import { useSelector } from 'react-redux';
import { getFlightDetailsByAircraftId } from '../../redux/selectors/flyingPage';
import { SOS, SPIDERWATCH, ACTIVE, RED, GREEN, BLUE } from '../Flying/AircraftList/constants';
import styled from 'styled-components';

const FlyingStatusStyled = styled.div`
  width: 15px;
  height: 15px;
  background: ${props => props.color};
  z-index: 9;
  border-style: solid;
  border-width: 2px;
  border-color: #000000;
  border-radius: 50%;
`;

interface AircraftStatusProps {
  aircraftId: string;
}
const TEN_MINUTES = 10 * 60 * 1000;
const TWO_MINUTES = 2 * 60 * 1000;
const FIFTEEN_MINUTES = 15 * 60 * 1000;

const YELLOW = '#FAAD14';
const GREY = '#BFBFBF';

const GREEN_R = parseInt(GREEN.slice(1, 3), 16); // 186
const GREEN_G = parseInt(GREEN.slice(3, 5), 16); // 217
const GREEN_B = parseInt(GREEN.slice(5, 7), 16); // 40

const YELLOW_R = parseInt(YELLOW.slice(1, 3), 16); // 250
const YELLOW_G = parseInt(YELLOW.slice(3, 5), 16); // 173
const YELLOW_B = parseInt(YELLOW.slice(5, 7), 16); // 20

const getStatusColourFromPointTime = (lastPointTime: number): string => {
  const now = Date.now();
  const timeElapsed = now - lastPointTime;

  if (timeElapsed <= TWO_MINUTES) {
    return GREEN;
  } else if (timeElapsed <= TEN_MINUTES) {
    const progress = (timeElapsed - TWO_MINUTES) / (TEN_MINUTES - TWO_MINUTES);

    // Interpolate between GREEN and yellow
    const red = Math.floor(GREEN_R + (YELLOW_R - GREEN_R) * progress);
    const green = Math.floor(GREEN_G + (YELLOW_G - GREEN_G) * progress);
    const blue = Math.floor(GREEN_B + (YELLOW_B - GREEN_B) * progress);
    return `rgb(${red}, ${green}, ${blue})`;
  } else if (timeElapsed <= FIFTEEN_MINUTES) {
    return YELLOW;
  } else {
    return GREY;
  }
};

export const StatusV2: React.FC<AircraftStatusProps> = ({ aircraftId }) => {
  let color: string;
  const flightDetails = useSelector(
    useSelector(state => getFlightDetailsByAircraftId(state, aircraftId))
  );

  const status = flightDetails?.aircraft.trackStatus;
  const isActive = flightDetails?.aircraft.isActive;
  const lastPoint = flightDetails?.track.points[flightDetails.track.points.length - 1];
  switch (status) {
    case SOS:
      color = RED;
      break;
    case SPIDERWATCH:
      color = isActive ? BLUE : GREY;
      break;
    case ACTIVE:
      color = lastPoint ? getStatusColourFromPointTime(lastPoint?.timestamp) : GREY;
      break;
    default:
      color = GREY; // Default color for unknown status
  }

  return <FlyingStatusStyled className="aircraft-status" color={color} />;
};
